<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">업무전달</span>
            <span class="txt">직원 간 업무를 전달 할 수 있도록 글을 작성할 수 있습니다.</span>
        </div>
        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link :to="`/madmin/board/list`" class="com-btn">목록</router-link>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: 560px" />
                    <col style="width: 150px" />
                    <col style="width: 560px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>
                            제목
                            <span class="imp">*</span>
                        </th>
                        <td colspan="3">
                            <input v-model="title" class="w100p" placeholder="제목을 입력하세요" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>참석팀</th>
                        <td colspan="3">
                            <input v-model="joinTeamName" class="w100p" placeholder="팀명을 입력하세요" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            참석자
                            <span class="imp">*</span>
                        </th>
                        <td colspan="3">
                            <span v-for="(item, index) in staffBtn" :key="index" class="del-info">
                                <span class="txt">{{ item.name }}</span>
                                <button class="del" @click="onDelStaff(item.staffId)">
                                    <span class="blind">삭제</span>
                                </button>
                            </span>
                            <!--
                        <span class="del-info">
                            <span class="txt">김하연</span>
                            <button class="del"><span class="blind">삭제</span></button>
                        </span>
                        -->
                            <button class="plus-btn" @click="onAttendPop">참석자 선택</button>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            진행여부
                            <span class="imp">*</span>
                        </th>
                        <td colspan="3">
                            <select-form
                                :select-data="['진행중', '처리완료']"
                                :select-value="['O', 'C']"
                                :selected-value="status"
                                class="w100"
                                @update:set="(val) => (status = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>내용</th>
                        <td colspan="3">
                            <ckeditor v-model="editorData" :config="editorConfig" :editor="editor"></ckeditor>
                        </td>
                    </tr>
                    <tr>
                        <th>알림설정</th>
                        <td>
                            <div class="flex">
                                <div class="com-radio">
                                    <input
                                        id="radio-edit-1-1"
                                        v-model="pushYn"
                                        name="radio-edit-1"
                                        type="radio"
                                        value="true"
                                    />
                                    <label for="radio-edit-1-1">푸시</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-edit-1-2"
                                        v-model="pushYn"
                                        name="radio-edit-1"
                                        type="radio"
                                        value="false"
                                    />
                                    <label for="radio-edit-1-2">안함</label>
                                </div>
                            </div>
                        </td>
                        <th>공지등록</th>
                        <td>
                            <div class="flex">
                                <div class="com-radio">
                                    <input
                                        id="radio-edit-2-1"
                                        v-model="noticeYn"
                                        :value="true"
                                        name="radio-edit-2"
                                        type="radio"
                                    />
                                    <label for="radio-edit-2-1">등록</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-edit-2-2"
                                        v-model="noticeYn"
                                        :value="false"
                                        name="radio-edit-2"
                                        type="radio"
                                    />
                                    <label for="radio-edit-2-2">등록안함</label>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            공지등록 기간
                            <span class="imp">*</span>
                        </th>
                        <td colspan="3">
                            <div class="flex">
                                <select-form
                                    :select-data="['7일', '15일', '30일', '무기한', '기간설정']"
                                    :select-value="[7, 15, 30, 0, 99]"
                                    :selected-value="noticeType"
                                    class="w100"
                                    @update:set="(val) => setNoticeType(val)"
                                ></select-form>
                                <div class="com-calendar-wrap">
                                    <single-calendar
                                        :date="noticeStartDate"
                                        :disabled="noticeType != '99'"
                                        @update="(val) => (noticeStartDate = val)"
                                    ></single-calendar>
                                    <div class="com-dash"><span class="dash">~</span></div>
                                    <single-calendar
                                        :date="noticeEndDate"
                                        :disabled="noticeType != '99'"
                                        @update="(val) => (noticeEndDate = val)"
                                    ></single-calendar>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn" to="/madmin/board/list">목록</router-link>
                    <button v-if="boardStatus === 'edit'" class="com-btn blue" @click="onSumbit">등록</button>
                    <button v-else-if="boardStatus === 'modify'" class="com-btn blue" @click="onUpdate">수정</button>
                </div>
            </div>
        </div>

        <!-- 카테고리 설정 팝업 -->
        <div v-show="attendPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="attendPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">참석자 추가</span>

                    <div class="people-search-box">
                        <div class="top-input">
                            <input v-model="searchStr" placeholder="이름을 검색하세요" type="text" />
                            <button class="com-btn" @click="onSearchStaff">검색</button>
                        </div>
                        <div v-show="staffSearchResult.length" class="view-scroll-box com-scroll-y">
                            <div class="all-check">
                                <div class="com-check">
                                    <input v-model="allSelected" name="user-check-all" type="checkbox" />
                                    <label for="user-check-all" @click="onSelectAll">전체선택</label>
                                </div>
                            </div>
                            <div class="user-info flex-col">
                                <div v-for="(items, index) in staffSearchResult" :key="index" class="com-check">
                                    <input
                                        :id="`user-check-${index}`"
                                        v-model="staffSelectResult"
                                        :value="items.c_center_staff_id"
                                        type="checkbox"
                                        @change="onChangeCheck"
                                    />
                                    <label :for="`user-check-${index}`">{{ items.c_namee }}</label>
                                </div>
                                <!--
                                <div class="com-check">
                                    <input type="checkbox" name="user-check" id="user-check-1">
                                    <label for="user-check-1">강용현</label>
                                </div>
                                <div class="com-check">
                                    <input type="checkbox" name="user-check" id="user-check-2">
                                    <label for="user-check-2">강용현</label>
                                </div>
                                <div class="com-check">
                                    <input type="checkbox" name="user-check" id="user-check-3">
                                    <label for="user-check-3">강용현</label>
                                </div>
                                <div class="com-check">
                                    <input type="checkbox" name="user-check" id="user-check-4">
                                    <label for="user-check-4">강용현</label>
                                </div>
                                <div class="com-check">
                                    <input type="checkbox" name="user-check" id="user-check-5">
                                    <label for="user-check-5">강용현</label>
                                </div>
                                -->
                            </div>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="attendPop = false">취소</button>
                        <button class="com-btn blue" @click="onAttendSelect">선택</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import moment from 'moment';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor.js';
import SimpleUpload from '../../../assets/js/ckeditor/simpleUpload';

export default {
    name: 'BoardEdit',
    props: {},
    computed: {},
    data() {
        return {
            centerId: this.$store.state.auth.user.centerId,
            centerStaffId: this.$store.state.auth.user.uid,
            centerTaskId: this.$route.params.centerTaskId,

            title: '',
            joinTeamName: '',
            status: 'O',
            noticeYn: false,
            noticeType: '7',
            noticeStartDate: '',
            noticeEndDate: '',
            pushYn: false,
            centerStaffIdList: [],

            attendPop: false,
            searchStr: '',
            staffSearchResult: [],
            staffSelectResult: [],
            staffBtn: [], // 테이블 표시 참석표 버튼
            allSelected: false,

            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },
        };
    },
    computed: {
        boardStatus() {
            if (this.$route.params.centerId === undefined && this.$route.params.centerTaskId === undefined) {
                return 'edit'; // 글을 새로 등록하는 상태
            } else if (this.$route.params.centerId !== undefined && this.$route.params.centerTaskId !== undefined) {
                return 'modify'; // 기존 글을 수정하는 상태
            }
            return 'error'; // 잘못된 URL을 이용해서 접근해서 생기는 오류
        },
    },
    mounted() {
        this.init();

        /* 공지등록 기간 초기값 설정 */
        /*
        this.noticeStartDate = moment().format('YYYY-MM-DD');
        this.noticeEndDate = moment().add(7, 'days').format('YYYY-MM-DD');
        */
    },
    methods: {
        async init() {
            if (this.boardStatus === 'edit') {
                this.noticeStartDate = moment().format('YYYY-MM-DD');
                this.noticeEndDate = moment().add(7, 'days').format('YYYY-MM-DD');
            } else if (this.boardStatus === 'modify') {
                const { data } = await this.getCenterTaskDetail(this.$route.params);
                this.title = data.title;
                this.joinTeamName = data.joinTeamName;
                this.status = data.status;
                this.editorData = data.content;
                this.pushYn = data.pushYn;
                this.noticeYn = data.noticeYn;
                this.noticeType = data.noticeType;
                this.noticeStartDate = data.noticeStartDate;
                this.noticeEndDate = data.noticeEndDate;
                this.staffSelectResult = data.centerTaskStaffs;

                this.staffSelectResult.forEach((staff) => {
                    const item = {};
                    item.name = staff.center_staff_nm;
                    item.staffId = staff.center_staff_id;
                    this.staffBtn.push(item);
                    this.centerStaffIdList.push(item.staffId);
                });
            } else {
                alert('잘못된 URL에 의해서 접근했습니다.');
                this.$router.push({ name: 'BoardList' });
            }
        },
        async onSumbit() {
            try {
                // 제목
                if (this.title === '') {
                    alert('제목을 입력하세요.');
                    return;
                }

                // 참석자
                if (this.centerStaffIdList.length === 0) {
                    alert('참석자를 선택하세요.');
                    return;
                }

                const data = await this.sendPostWork();

                console.log(data);
                this.$router.push({ path: `/madmin/board/list/` });
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        sendPostWork(data) {
            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            this.editorData = editorInstance.getData();

            return api.post(`/admin/api/centerTask/create/${this.centerId}`, {
                centerStaffId: this.centerStaffId,
                title: this.title,
                joinTeamName: this.joinTeamName,
                content: this.editorData,
                status: this.status,
                noticeYn: this.noticeYn,
                noticeType: this.noticeType,
                noticeStartDate: this.noticeStartDate,
                noticeEndDate: this.noticeEndDate,
                pushYn: this.pushYn,
                centerStaffIdList: this.centerStaffIdList,
            });
        },
        // 참석자 검색
        onSearchStaff() {
            this.allSelected = false;
            this.staffSelectResult = [];
            this.staffSelectResult = [];
            this.searchStaffList();
        },
        async searchStaffList() {
            try {
                const { data } = await this.getStaffList();
                console.log('===> Success Load staffList : ', data);
                this.staffSearchResult = data.items;
            } catch (error) {
                console.log(error);
            }
        },
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/list/pagaing`, {
                params: {
                    centerId: this.centerId,
                    page: 1,
                    limit: 0,
                    searchStr: this.searchStr,
                },
            });
        },
        setNoticeType(val) {
            if (val == '7') {
                this.noticeStartDate = moment().format('YYYY-MM-DD');
                this.noticeEndDate = moment().add(7, 'days').format('YYYY-MM-DD');
            } else if (val == '15') {
                this.noticeStartDate = moment().format('YYYY-MM-DD');
                this.noticeEndDate = moment().add(15, 'days').format('YYYY-MM-DD');
            } else if (val == '30') {
                this.noticeStartDate = moment().format('YYYY-MM-DD');
                this.noticeEndDate = moment().add(30, 'days').format('YYYY-MM-DD');
            } else if (val == '0') {
                // this.noticeStartDate = moment().format('YYYY-MM-DD');
                // this.noticeEndDate = moment().add(1, 'years').format('YYYY-MM-DD');
            }

            this.noticeType = val;
        },
        onSelectAll() {
            this.allSelected = !this.allSelected;
            this.staffSelectResult = [];

            if (this.allSelected) {
                this.staffSearchResult.forEach((element) => {
                    this.staffSelectResult.push(element.c_center_staff_id);
                });
            }
        },
        // 참석자 추가 팝업 열기
        onAttendPop() {
            this.staffSearchResult = [];
            this.staffSelectResult = [];
            this.attendPop = true;
        },
        onChangeCheck() {
            if (this.staffSelectResult.length == this.staffSearchResult.length) {
                this.allSelected = true;
            } else {
                this.allSelected = false;
            }
        },
        // 참석자 추가 팝업 참석자선택
        onAttendSelect() {
            if (!this.staffSelectResult.length) {
                alert('참석자를 선택해 주세요.');
            } else {
                if (!this.staffBtn) {
                    console.log('값이없습니다.');
                    this.staffBtn = []; // 첫번째만
                    this.centerStaffIdList = [];
                }
                this.attendPop = false;
                this.searchStr = ''; // input값 초기화

                this.staffSelectResult.forEach((element) => {
                    this.staffSearchResult.forEach((subElement) => {
                        if (element === subElement.c_center_staff_id) {
                            this.centerStaffIdList.push(subElement.c_center_staff_id);
                            this.staffBtn.push({
                                staffId: subElement.c_center_staff_id,
                                name: subElement.c_namee,
                            });
                        }
                    });
                });
            }
        },
        onDelStaff(staffId) {
            this.staffBtn.forEach((element, index) => {
                if (staffId == element.staffId) {
                    this.centerStaffIdList.splice(index, 1);
                    this.staffBtn.splice(index, 1);
                }
            });
        },
        getCenterTaskDetail(params) {
            const { centerId, centerTaskId } = params;
            return api.get(`admin/api/centerTask/detail/${centerId}/${centerTaskId}`);
        },
        // 해당 함수의 글을 수정하는 API가 존재하지 않습니다. 추후에 API가 추가된다면 수정해야 합니다.
        async onUpdate() {
            try {
                // 제목
                if (this.title === '') {
                    alert('제목을 입력하세요.');
                    return;
                }

                // 참석자
                if (this.centerStaffIdList.length === 0) {
                    alert('참석자를 선택하세요.');
                    return;
                }

                const domEditableElement = document.querySelector('.ck-editor__editable');
                const editorInstance = domEditableElement.ckeditorInstance;
                this.editorData = editorInstance.getData();
                await this.putCenterTask({
                    centerStaffId: this.centerStaffId,
                    joinTeamName: this.joinTeamName,
                    title: this.title,
                    content: this.editorData,
                    status: this.status,
                    noticeYn: this.noticeYn,
                    noticeType: this.noticeType,
                    noticeStartDate: this.noticeStartDate,
                    noticeEndDate: this.noticeEndDate,
                    pushYn: this.pushYn,
                    centerStaffIdList: this.centerStaffIdList,
                });

                this.$router.push({ path: '/madmin/board/list' });
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        putCenterTask(params) {
            return api.put(`/admin/api/centerTask/updateCenterTask/${this.centerId}/${this.centerTaskId}`, params);
        },
    },
};
</script>
<style lang="scss"></style>
